import { BasicCommand } from "./BasicCommand";
/**
 * Created with IntelliJ IDEA.
 * User: aprzybyszewski
 * Date: 30.04.13
 * Time: 14:32
 * To change this template use File | Settings | File Templates.
 */


import { BasicController } from "../BasicController";
import { BasicSmartfoxConstants } from "../BasicSmartfoxConstants";
import { CommandController } from './../../../commanding/CommandController';

export class LPPCommand extends BasicCommand {
    protected get cmdId(): string {
        return BasicSmartfoxConstants.S2C_LOST_PASSWORD_EVENT;
    }

    public executeCommand(error: number, params: any[]): boolean {
        CommandController.instance.executeCommand(BasicController.COMMAND_LOST_PASSWORD, error);
        return super.executeCommand(error, params);
    }
}

